module.exports = "/assets/bee6a6c837ae22b262dd84bc81a14353.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IB.png
// module id = 1468
// module chunks = 0